<p-checkbox class="mr-2" [ngModel]="_value > 0" [binary]="true" (ngModelChange)="change($event)"></p-checkbox>
<p-badge *ngIf="_value > 0" class="mouse-pointer" [class.greyed]="_value == 1" [value]="'' + _value" (click)="click()"></p-badge>
